export const postbackURL = process.env.REACT_APP_POSTBACK_URL;
export const postbackDomain = process.env.REACT_APP_POSTBACK_DOMAIN;
export const accessApiUrl = process.env.REACT_APP_ACCESS_API_URL;
export const adsManagerApiUrl = process.env.REACT_APP_ADS_MANAGER_API_URL;
export const clickApiUrl = process.env.REACT_APP_CLICK_API_URL;
export const stripePK = process.env.REACT_APP_STRIPE_PK;
export const GA4Status = process.env.REACT_APP_GA4_STATUS;
export const GA4MeasurementID = process.env.REACT_APP_GA4_MEASUREMENT_ID;
export const adsManagerPublicAPIDoc = process.env.REACT_APP_ADS_MANAGER_PUBLIC_API_DOC;